import axios from 'axios';
import { IIntegrationStatus } from '@/settings/integrations/types/integration-list-item';
import { IIntegrationModalDetails } from '@/settings/integrations/types/integration-modal';
import { ILimeField } from '@/settings/integrations/types/integration-lime-field';
export default class IntegrationService {
  static loadStatuses = async (): Promise<IIntegrationStatus[]> => {
    const {
      data: { integrations },
    } = await axios.get('/get/integration/list');
    return integrations || [];
  };

  static loadDetails = async (name: string): Promise<IIntegrationModalDetails> => {
    const {
      data: { integration },
    } = await axios.get(`/get/integration/${name}/details`);
    return (
      {
        externalUrl: integration.external_url,
        haveToken: integration.have_token,
        identifier: integration.identifier,
        metaData1: integration.meta_data_1,
        metaData2: integration.meta_data_2,
        metaData3: integration.meta_data_3,
        name: integration.name,
        profile: integration.profile,
        status: integration.status,
        userId: integration.user_id,
      } || null
    );
  };

  static setDetails = async (newDetails: IIntegrationModalDetails): Promise<number> => {
    const data = new FormData();
    data.append('integration-identifier', newDetails.identifier);
    data.append('integration-token', newDetails.haveToken);
    data.append('integration-meta_data_1', newDetails.metaData1);
    data.append('integration-external_url', newDetails.externalUrl);
    data.append('integration-meta_data_2', newDetails.metaData2);
    data.append('integration-meta_data_3', newDetails.metaData3);
    data.append('action', 'save');
    data.append('integration-status', newDetails.status);
    data.append('integration-user_id', newDetails.userId);
    data.append('integration-name', newDetails.name);
    const {
      data: { integration },
    } = await axios.post('/save/integration', data);
    return integration;
  };

  static disconnect = async (name: string): Promise<number> => {
    const data = new FormData();
    data.append('action', 'delete');
    data.append('integration-name', name);
    const {
      data: { integration },
    } = await axios.post('/save/integration', data);
    return integration;
  };

  static loadLimeCrmFields = async (domain: string): Promise<ILimeField[]> => {
    const data = new FormData();
    data.append('domain', domain);
    data.append('action', 'limetype');
    data.append('table', 'document');
    const {
      data: { fields },
    } = await axios.post('/get/integration/limecrm/limetype', data);
    return fields as ILimeField[];
  };

  static generateSCIMData = async (): Promise<Partial<IIntegrationModalDetails>> => {
    const {
      data: { integration },
    } = await axios.post('/get/integration/scim/generate');
    return {
      externalUrl: integration.external_url,
      haveToken: integration.token,
    };
  };

  static generateSympaData = async (): Promise<Partial<IIntegrationModalDetails>> => {
    const {
      data: { integration },
    } = await axios.get('/get/integration/sympa/generate');
    return {
      haveToken: integration.token,
    };
  };

  static generateEmailDocImpData = async (): Promise<Partial<IIntegrationModalDetails>> => {
    const {
      data: { integration },
    } = await axios.post('/get/integration/email/generate');
    return {
      externalUrl: integration.general_url,
      identifier: integration.unique_url,
    };
  };
}
